import React, { memo, useContext } from 'react'
import { DarkContext } from '../context/darkMode'

function DarkModeWrapper({ children }) {
    const { isDark } = useContext(DarkContext)
    return (
        <div className={isDark ? 'dark' : ''} id='dark-mode-wrapper'>{children}</div>
    )
}


export default memo(DarkModeWrapper)